module.exports = __webpack_public_path__ + "img/app-screen.54ae0fcb.png";